<template>
    <form v-show="isInputFormActive" method="POST">
        <div class="row">
            <div class="col-lg-3 col-md-3 col-12">
                <div class="form-group">
                    <label for="itemname">Creditor</label>
                    <select
                        v-model="selectedCreditorId"
                        id="creditbureau"
                        name="creditbureau"
                        class="form-control"
                        :class="{'is-invalid' : creditorError}"
                        required
                    >
                        <option v-for="creditor in creditors" v-bind:value="creditor.id">{{ creditor.creditor_name }}</option>
                    </select>
                    <span v-if="creditorError" class="invalid-feedback" role="alert">
                        <strong>Field is Required</strong>
                    </span>
                </div>
            </div>
            <div class="col-lg-9 col-md-9 col-12">
                <!-- search input -->
                <div class="custom-search d-flex justify-content-end">
                    <div class="form-group">
                        <label>&nbsp;</label>
                        <div class="d-flex align-items-center">
                            <label class="mr-1">Search</label>
                            <input
                                v-model="searchTerm"
                                placeholder="Search"
                                type="text"
                                class="d-inline-block form-control"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
    <vue-good-table
      v-show="isInputFormActive"
      :columns="columns"
      :rows="rows"
      :search-options="{
        enabled: true,
        externalQuery: searchTerm
      }"
      :select-options="{
        enabled: true,
        disableSelectInfo: true,
        selectOnCheckboxOnly: true
      }"
    >
        <template #table-row="props">
            <span v-if="props.column.field === 'action'">
                <div class="d-flex align-items-center col-actions">
                    <a class="mr-1 text-primary" data-toggle="tooltip" data-placement="top" title="Individual Dispute">
                        <vue-feather type="send" @click="dispute(props.row.id)"></vue-feather>
                    </a>
                </div>
            </span>
        </template>
    </vue-good-table>
    <section v-show="!isInputFormActive">
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-header p-0 mb-50 mx-auto">
                        <a class="go-back" @click="goBack" >{{ localizationStore.translate("letter.create.back.button.text") }}</a>
                    </div>
                    <div class="card-content">
                        <div class="card-body">
                            <form :action="routes.createLetterRoute" method="post" enctype="multipart/form-data" class="row">
                                <input type="hidden" name="_token" :value="csrf">
                                <input type="text" class="form-control" id="creditbureau" name="creditbureau" :value="selectedCreditorId" hidden>
                                <div class="col-md-6 pl-md-0 pr-md-3">
                                    <div id="editor">
                                    </div>
                                    <div class="d-flex justify-content-center my-1">
                                        <button class="btn btn-sm-block btn-primary" type="submit" name="editorType" value="1">
                                            {{ localizationStore.translate("letter.left.submit.button.text") }}
                                        </button>
                                    </div>
                                </div>
                                <div class="col-md-6 pl-md-3 pr-md-0 mt-3 mt-md-0">
                                    <div class="arrow-btn">
                                        <button
                                            class="btn btn-outline-primary px-50"
                                            @click="$refs.spinner.spinLetter()"
                                            type="button"
                                        >
                                            {{ localizationStore.translate("spin.letter.button.text") }}
                                            <i data-feather="arrow-right"></i>
                                        </button>
                                    </div>
                                    <div id="editor-right">
                                    </div>
                                    <div class="d-flex justify-content-center my-1">
                                        <button class="btn btn-sm-block btn-primary" type="submit" name="editorType" value="2">
                                            {{ localizationStore.translate("letter.right.submit.button.text") }}
                                        </button>
                                    </div>
                                </div>
                                <spinner ref="spinner" :user-info='userInfo' :editor-ref='editorRefSingle' />
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div ref="editorRefSingle" hidden>
            <p>
                {{ userInfo.firstname }} {{ userInfo.lastname }}
                <br />
                {{ userInfo.address }}
                <br />
                {{ userInfo.city }}, {{ userInfo.state }} {{ userInfo.zipcode }}
                <br />
                <br />
                {{ selectedCreditor.creditor_name }}
                <br />
                <template v-if="selectedCreditor.address">
                    {{ selectedCreditor.address }}
                </template>
                <template v-else>
                    {{ selectedCreditor.address_line }}<br /> {{ selectedCreditor.city }}, {{ selectedCreditor.state }} {{ selectedCreditor.zipcode }}
                </template>
                <br />
                <br />
                Date: {{ date }}
            </p>
            <p>
                RE: Account #: {{ disputedCreditor.account_number }}
            </p>
            <p>
                To Whom It May Concern:
            </p>
            <p class="letter-content">
                This letter is a “qualified written request” under the Federal Servicer Act, which is a part of the Real Estate Settlement Procedures Act, 12 U.S.C. 2605(e). This request is made on the above referenced account. I have concerns about the way this account is reporting on my credit report, specifically there are late payments reporting on <strong>{{ disputedCreditor.account_number }}</strong>. I do not have record of this information. I am concerned about the accounting irregularities on my mortgage statement, including the way the escrow amount has been calculated and the application of my principal, interest and escrow payments.
            </p>
            <p class="letter-content">
                To clear up these issues, I am requesting the following
                information:
                <br><br>

                1. A complete and itemized statement of the loan history from the date of
                the loan to the date of this letter including, but not limited to, all
                receipts by way of payment or otherwise and all charges to the loan in
                whatever form. This history should include the date of each and every debit
                and credit to any account related to this loan, the nature and purpose of
                each such debit and credit, and the name and address of the payee of any
                type of disbursement related to this account.
            </p>
            <p class="letter-content">
                2. A complete and itemized statement of all advances or charges against this
                loan for any purpose that are not reflected on the loan history transaction
                statement provided in answer to question #1.
            </p>
            <p class="letter-content">
                3. A complete and itemized statement of the escrow account of the loan, if
                any, from the date of the loan to the date of this letter, including, but
                not limited to, any receipts or disbursements with respect to real estate
                property taxes, fire or hazard insurance, flood insurance, mortgage
                insurance, credit insurance, or any other insurance product.
            </p>
            <p class="letter-content">
                4. A complete and itemized statement from the date of the loan to the date
                of this letter of any forced-placed insurance and expenses related thereto,
                related in any way to this loan.
            </p>
            <p class="letter-content">
                5. A complete and itemized statement from the date of the loan to the date
                of this letter of any suspense account entries and/or any corporate advance
                entries related in any way to this loan.
            </p>
            <p class="letter-content">
                6. A complete and itemized statement from the date of the loan to the date
                of this letter of any property inspection fees, property preservation fees,
                broker opinion fees, appraisal fees, bankruptcy monitoring fees, or other
                similar fees or expenses related in any way to this loan.
            </p>
            <p class="letter-content">
                7. Identify the provision under the Deed of Trust and/or note that
                authorizes charging each and every such fee against the loan..
            </p>
            <p class="letter-content">
                8. A complete and itemized statement of any late charges to this loan from
                the date of this loan to the date of this letter.
            </p>
            <p class="letter-content">
                9. The amount, if applicable, of any “satisfaction fees.”
            </p>
            <p class="letter-content">
                10. A complete and itemized statement from the date of the loan to the date
                of this letter of any fees incurred to modify, extend, or amend the loan or
                to defer any payment due under the terms of the loan.
            </p>
            <p class="letter-content">
                11. The current amount needed to pay-off the loan in full.
            </p>
            <p class="letter-content">
                12. A full and complete comprehensible definitional dictionary of all
                transaction codes and other similar terms used in the statements requested
                above.
            </p>
            <p class="letter-content">
                13. A complete and itemized statement of any funds deposited in any
                post-petition suspension account(s) or corporate advance account(s),
                including, but not limited to, the balance in any such account or accounts
                and the nature, source and date of any and all funds deposited in such
                account or accounts.
            </p>
            <p class="letter-content">
                14. A complete and itemized statement from the date of this loan to the date
                of this letter of the amount, payment date, purpose and recipient of all
                foreclosure expenses, NSF check charges, legal fees, attorney fees,
                professional fees and other expenses and costs that have been charged
                against or assessed to this mortgage.
            </p>
            <p class="letter-content">
                15. A complete and itemized statement of the amount, payment date, purpose
                and recipient of all fees for the preparation and filing of the original
                proof of claim, any amended proofs of claim, or any supplemental proofs of
                claim related to this mortgage.
            </p>
            <p class="letter-content">
                16. The full name, address and phone number of the current holder of this
                debt including the name, address and phone number of any trustee or other
                fiduciary. This request is being made pursuant to Section 1641(f)(2) of the
                Truth In Lending Act, which requires the servicer to identify the holder of
                the debt.
            </p>
            <p class="letter-content">
                17. The name, address and phone number of any master servicers, servicers,
                sub-servicers, contingency servicers, back-up servicers or special servicers
                for the underlying mortgage debt.
            </p>
            <p class="letter-content">
                18. A copy of any mortgage Pooling and Servicing Agreement and all
                Disclosure Statements provided to any Investors with respect to any
                mortgage-backed security trust or other special purpose vehicle related to
                the said Agreement and any and all Amendments and Supplements thereto.
            </p>
            <p class="letter-content">
                19. If a copy of the Pooling and Servicing Agreement has been filed with the
                SEC, provide a copy of SEC Form 8k and the Prospectus Supplement, SEC Form
                424b5.
            </p>
            <p class="letter-content">
                20. The name, address and phone number of any Trustee under any pooling or
                servicing agreement related to this loan.
            </p>
            <p class="letter-content">
                21. A copy of the Prospectus offered to investors in the trust.
                <br> <br>
                22. Copies of all servicing, master servicing, sub-servicing, contingency
                servicing, special servicing, or back-up servicing agreements with respect
                to this account.
            </p>
            <p class="letter-content">
                23. The procedural manual used with respect to the servicing or
                sub-servicing of this loan..
            </p>
            <p class="letter-content">
                24. Is this mortgage part of a Whole Loan Sale Agreement? If the answer is
                yes, then state the name and address of the Purchaser, the Custodian, the
                Trustee, the Electronic Agent and any Servicer or Sub-Servicers.
            </p>
            <p class="letter-content">
                You should be advised that you must acknowledge receipt of this qualified
                written request within 20 business days, pursuant to 12 U.S.C. Section
                2605(e)(1)(A) and Reg. X Section 3500.21(e)(1).
            </p>
            <p class="letter-content">
                You should also be advised that I will seek the recovery of damages, costs,
                and reasonable legal fees for each failure to comply with the questions and
                requests herein. I also reserve the right to seek statutory damages for each
                violation of any part of Section 2605 of Title 12 of the United States Code.
            </p>
            <p class="letter-content">
                Through my intense research I found that the above items are required to be
                furnished to me upon my qualified request. I feel there are significant and
                substantial errors and or misrepresentations with the way this account is
                reflecting as a derogatory item on my credit report. The only way to
                definitively conclude the accuracy of the reporting is to review all of the
                above items. I have received statements from several different mortgage
                companies/servicers since the origination of this loan. In my research I
                uncovered several situations similar to mine where payments were improperly
                applied to the wrong company and account.
            </p>
            <p class="letter-content">
                In the interest of saving time and trees, if you feel it is easier to delete
                all reporting of this account permanently, then I will waive my right to
                request copies of the information itemized above. If you choose to delete
                the account due to the possible errors rather than supply the requested
                data, please send confirmation in writing to that effect within 10 days of
                receipt of this letter. If you choose to provide the above documentation as
                per this qualified written request, please also follow RESPA guidelines as
                outlined in the Federal RESPA statutes and immediately cease any
                negative/derogatory credit reporting of this account until all of the
                documentation above has been provided to prove the accuracy of your
                reporting.
            </p>
            <p>
                {{ userInfo.firstname }} {{ userInfo.lastname }}
                <br>
                <template v-if="selectedCreditor.address">
                    {{ selectedCreditor.address }}
                </template>
                <template v-else>
                    {{ selectedCreditor.address_line }}<br /> {{ selectedCreditor.city }}, {{ selectedCreditor.state }} {{ selectedCreditor.zipcode }}
                </template>
                <br><br>
                Cc; Department of Housing and Urban Development, Office of Thrift Supervision <br>
                Cc; U.S. House of Representatives Financial Services Committee <br>
                Cc; Attorney General’s Office
            </p>
        </div>
    </section>
</template>
<script>
  import { reactive, computed, ref } from 'vue'
  import 'vue-good-table-next/dist/vue-good-table-next.css'
  import { VueGoodTable } from 'vue-good-table-next';
  import { useLocalizationStore } from '../../stores/LocalizationStore.js'
  export default {
    props: {
        csrf: {
            type: String
        },
        creditors: {
            type: [Array, Object]
        },
        userInfo: {
            type: [Array, Object]
        },
    },
    components: {
        VueGoodTable,
    },
    setup(props) {
        const selectedCreditorId = ref(props.creditors[0].id);
        const editorRefSingle = ref(null);
        const isInputFormActive = ref(true),
            creditorError = ref(false),
            date = ref(null);
        return {
            selectedCreditorId,
            editorRefSingle,
            isInputFormActive,
            creditorError,
            date,
            localizationStore: useLocalizationStore()
        };
    },
    data(){
        const disputedCreditor = reactive([]);
        return {
          columns: [
            {
              label: 'CREDITOR',
              field: 'furnisher_name',
            },
            {
              label: 'ACCOUNT NUMBER',
              field: 'account_number',
            },
            {
              label: 'PAYMENT STATUS',
              field: 'payment_status',
            },
            {
              label: 'Action',
              field: 'action',
            }
          ],
          rows: [],
          searchTerm: '',
          disputedCreditor
        };
    },
    created() {
        // console.log(this.creditors);
    },
    mounted() {
        axios.get(this.routes.currentDate).then(response => (this.date = response.data));
        this.getCreditorList();
    },
    computed: {
        // a computed getter
        selectedCreditor() {
            return this.creditors.find((attribute) => {
                if (attribute.id == this.selectedCreditorId) {
                    return attribute;
                }
            })
        }
    },
    methods: {
      dispute: function (id) {
        this.disputedCreditor = this.rows.find((attribute) => {
            if (attribute.id == id) {
                return attribute;
            }
        });
        setTimeout(() => {
            tinymce.get('editor').setContent(this.editorRefSingle.innerHTML);
            this.isInputFormActive = !this.isInputFormActive;
        }, "100");
      },
      goBack: function () {
        this.isInputFormActive = !this.isInputFormActive;
      },
      validate: function () {
        if (this.selectedCreditorId == null || this.selectedCreditorId == "null") {
            this.creditorError = true;
        }
        else {
            this.creditorError = false;
        }
        return !this.creditorError;
      },
      getCreditorList: function () {
        axios.get(this.routes.listCreditBureau.replace(':type', 1)).then(response => {
                this.rows = response.data.data
            }
        );
      }
    }
  };
</script>
